import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PictionJS from 'piction-js';
import { List } from 'immutable';
import { useEffect, useRef } from 'react';

import piction from '../../utils/piction';
import appConfig from '../../appConfig';
import { setIndex } from '../../actions/umoCarousel';
import { setMetaUmoId } from '../../actions/mainUI';

const mapStateToProps = (state) => ({
  umoCarousel: new Map(state.umoCarousel),
  mainUI: new Map(state.mainUI),
});

const mapDispatchToProps = (dispatch) => ({
  setIndex: (index) => dispatch(setIndex(index)),
  setMetaUmoId: (id) => dispatch(setMetaUmoId(id)),
  dispatch: (actionToDispatch) => dispatch(actionToDispatch),
});

// todo: refactor. remove isNotJustified, use classNameModifier -- i.e. same as workspace preview
function UMOCarouselReel({
  umoList,
  umoCarousel,
  setIndex,
  setMetaUmoId,
  mainUI,
}) {
  const reelRef = useRef(null);
  const activeItemRef = useRef(null);

  const umoItems = [];
  const currentIndex = umoCarousel.get('currentIndex');

  /**
   * useEffect hook responsible to Scroll active item 
   * into view when currentIndex changes
   */
  useEffect(() => {
    if (activeItemRef.current && reelRef.current) {
      const reelContainer = reelRef.current;
      const activeItem = activeItemRef.current;

      const reelRect = reelContainer.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();

      const scrollLeft =
        activeItem.offsetLeft - reelRect.width / 2 + itemRect.width / 2;

      reelContainer.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  }, [currentIndex]);

  const onReelItemClick = (index, id) => {
    setIndex(index);
    // setMetaUmoId(id); // Commented to disable the meta data trigger in carousel view
  };

  for (let i = 0; i < umoList.size; i += 1) {
    const tempUMO = new PictionJS.UMO(umoList.get(i).toJS(), {
      hostURL: piction.hostURL,
    });
    if (i === currentIndex && mainUI.get('isMetaPanelShown'))
      setMetaUmoId(tempUMO.id);
    let url;
    const isRestricted = tempUMO.thumbnail._data.$.restricted === 'T';
    if (isRestricted) url = './images/thumb/restricted.jpg';
    else if (
      parseInt(tempUMO.thumbnail._data.$.tsize) !== 0 &&
      tempUMO.type !== 'RELATIONAL'
    ) {
      url = tempUMO.thumbnail.url;
    } else {
      switch (tempUMO.type) {
        case 'AUDIO':
          url = './images/thumb/audio.jpg';
          break;
        case 'DOCUMENT':
          url = './images/thumb/document.jpg';
          break;
        case 'RELATIONAL':
          url = './images/thumb/relational.gif';
          break;
        case 'PHOTO':
          url = tempUMO.webQuality.url;
          break;
        case 'VIDEO':
          url = './images/thumb/video.jpg';
          break;
        default:
          url = './images/thumb/img_nothumb.gif';
          break;
      }
    }
    const titleMetatag =
      appConfig.umoTitleMetatag &&
      ((tempUMO.tombstoneMetadataList.getMetadata(appConfig.umoTitleMetatag) &&
        tempUMO.tombstoneMetadataList.getMetadata(appConfig.umoTitleMetatag)
          .value) ||
        (tempUMO.metadataList.getMetadata(appConfig.umoTitleMetatag) &&
          tempUMO.metadataList.getMetadata(appConfig.umoTitleMetatag).value));
    const title = titleMetatag || tempUMO.name;
    const className = `img-reel${currentIndex == i ? ' active' : ''}`;

    // Adding ref to the active item
    const itemRef = currentIndex === i ? activeItemRef : null;

    umoItems.push(
      <div
        ref={itemRef}
        className={className}
        key={tempUMO.id}
        onClick={() => {
          onReelItemClick(i, tempUMO.id);
        }}
      >
        <img src={url} alt={appConfig.umoTitleMetatag ? title : ''} />
      </div>
    );
  }

  return (
    <div ref={reelRef} className="reel">
      {umoItems}
    </div>
  );
}

UMOCarouselReel.propTypes = {
  umoList: PropTypes.instanceOf(List),
  umoCarousel: PropTypes.instanceOf(Map),
  setIndex: PropTypes.func,
  setMetaUmoId: PropTypes.func,
  mainUI: PropTypes.instanceOf(Map),
};

export default connect(mapStateToProps, mapDispatchToProps)(UMOCarouselReel);
